import { INGTimeZonePickerProps } from "../../library/NGFieldExtensions";
import { allTimezones, useTimezoneSelect } from "react-timezone-select";
import NGMultiSelect from "../NGMultiSelect/NGMultiSelect";
import { MultiSelect } from "../../../resolvers-types";
import { getOffsetMinutes, getTestId, getTimeZoneOffset } from "../../library/utils";
import { getTypename } from "../../library/metadataUtils";
import { useComputed, useSignalEffect } from "@preact/signals-react";
import { getBrowserTimeZone, getUserProfileTimeZone } from "../../library/dataService";
import { Alert } from "@mui/material";
import { has, isNil } from "lodash-es";

export default function NGTimeZonePicker({ config, context }: INGTimeZonePickerProps) {
  const { options } = useTimezoneSelect({ labelStyle: "abbrev", timezones: allTimezones });

  const autoSelect = has(config, "AutoSelect") ? config.AutoSelect : true;

  const selectConfig = {
    ...config,
    Id: getTestId(config, "select"),
    __typename: "MultiSelect",
    MultiSelectPossibleValues: options,
    ValueExpression: "value",
    LabelExpression: "label",
    DefaultValue: autoSelect
      ? options.find((x) => x.offset === getTimeZoneOffset(getUserProfileTimeZone() ?? getBrowserTimeZone()))?.value
      : config.DefaultValue,
  };

  const mismatch = useComputed(() => {
    const browserTz = getBrowserTimeZone();
    const profileTz = getUserProfileTimeZone();

    if (isNil(profileTz)) return false;

    return getOffsetMinutes(browserTz) !== getOffsetMinutes(profileTz);
  });

  return (
    <div data-testid={getTestId(config)} data-type={getTypename(config)}>
      <NGMultiSelect config={selectConfig as MultiSelect} context={context} />
      {mismatch.value && (
        <Alert severity="warning">
          Your browser timezone {getBrowserTimeZone()} does not match your saved profile timezone{" "}
          {getUserProfileTimeZone()}
        </Alert>
      )}
    </div>
  );
}
